import { render, staticRenderFns } from "./blog-storage-usage.vue?vue&type=template&id=2031b9d9&scoped=true"
import script from "./blog-storage-usage.vue?vue&type=script&lang=js"
export * from "./blog-storage-usage.vue?vue&type=script&lang=js"
import style0 from "./blog-storage-usage.vue?vue&type=style&index=0&id=2031b9d9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2031b9d9",
  null
  
)

export default component.exports